import React from 'react';
import { motion } from 'framer-motion';
import { Lock, AlertTriangle, Zap, FileText, ShieldCheck } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
import { CountdownTimer } from './CountdownTimer';
export function OfferBlock() {
  const handleBuyClick = () => {
    trackAddToCart();
    window.location.href = 'https://clavedepaz.com/cart/44115100106851:1';
  };
  return <section id="offer" className="bg-slate-900 py-24 px-6 border-y border-slate-800 relative overflow-hidden" data-id="element-149">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-5 pointer-events-none" data-id="element-150">
        <div className="absolute top-[20%] left-[50%] -translate-x-1/2 w-[80%] h-[80%] rounded-full bg-red-600 blur-[150px]" data-id="element-151"></div>
      </div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-152">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white p-8 md:p-12 rounded-2xl shadow-2xl shadow-red-900/20 border-2 border-red-100 relative" data-id="element-153">
          <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-red-600 text-white px-6 py-1.5 rounded-full text-sm font-bold flex items-center gap-2 shadow-lg whitespace-nowrap" data-id="element-154">
            <span className="w-2 h-2 rounded-full bg-white animate-ping" data-id="element-155"></span>
            OFERTA POR TIEMPO LIMITADO
          </div>

          <h2 className="font-playfair text-3xl md:text-4xl font-bold text-slate-900 mb-4 mt-4" data-id="element-156">
            Qué decirle a tu ex sin empeorar el conflicto (y sin afectar a tus hijos).
          </h2>

          <p className="text-lg text-slate-600 mb-6 max-w-xl mx-auto" data-id="element-157">
            Aprendé exactamente cómo responder en momentos difíciles, evitar discusiones innecesarias y mantener el control cuando más importa.
          </p>

          <div className="bg-slate-50 rounded-xl p-6 mb-8 border border-slate-100" data-id="element-158">
            <div className="text-sm font-bold text-red-600 uppercase tracking-wider mb-2 flex items-center justify-center gap-2" data-id="element-159">
              <AlertTriangle size={16} data-id="element-160" />
              La oferta termina pronto
            </div>

            <CountdownTimer data-id="element-161" />

            <p className="text-sm text-slate-500 font-medium mt-2" data-id="element-162">
              Cuando el contador llegue a 0, el precio vuelve a $15,999
            </p>
          </div>

          <div className="mb-8" data-id="element-163">
            <div className="flex items-end justify-center gap-3 mb-3" data-id="element-164">
              <div className="text-6xl md:text-7xl font-bold text-green-600 font-playfair leading-none" data-id="element-165">
                $7,999
              </div>
              <div className="text-2xl text-slate-400 line-through font-medium mb-1" data-id="element-166">
                $15,999
              </div>
            </div>
            <div className="inline-flex items-center gap-2 bg-amber-100 text-amber-800 px-3 py-1 rounded-full text-sm font-bold mb-4" data-id="element-167">
              <FileText size={14} data-id="element-168" />
              Formato PDF · Descarga inmediata · Acceso de por vida
            </div>
          </div>

          <button onClick={handleBuyClick} className="bg-green-600 hover:bg-green-700 text-white font-bold text-xl md:text-2xl py-5 px-8 rounded-xl shadow-xl shadow-green-600/30 transition-all transform hover:scale-105 active:scale-95 w-full mb-4 border-b-4 border-green-800" data-id="element-169">
            COMPRAR AHORA (Acceso inmediato)
          </button>

          <p className="text-sm text-slate-500 mb-6 font-medium" data-id="element-170">
            Ebook digital (PDF). No es libro físico. Recibirás el acceso
            inmediatamente después del pago.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6 text-sm text-slate-600 font-medium" data-id="element-171">
            <div className="flex items-center justify-center gap-2 bg-slate-50 py-2 rounded-lg" data-id="element-172">
              <ShieldCheck size={16} className="text-green-600" data-id="element-173" />
              <span data-id="element-174">Pago 100% seguro</span>
            </div>
            <div className="flex items-center justify-center gap-2 bg-slate-50 py-2 rounded-lg" data-id="element-175">
              <Zap size={16} className="text-amber-500" data-id="element-176" />
              <span data-id="element-177">Acceso instantáneo</span>
            </div>
            <div className="flex items-center justify-center gap-2 bg-slate-50 py-2 rounded-lg" data-id="element-178">
              <FileText size={16} className="text-blue-500" data-id="element-179" />
              <span data-id="element-180">PDF descargable</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}